import { atom } from "jotai";
import { get_all_activities, getActivities, getBlockData, getbomlist, getBulkBlock, getConstructionProgress, getCount, getMapSize, getOverAllSvg, getPartList, getPierLegends, getsvgbomlistS, getSVGConstructionProgressBlockWise, getTrackers, getTypeData } from "../../services/dashboard/index";
import axiosInstance from "../../utils/axios";


const dashboardAtoms = atom({
    projectList: [],
    constructionList: {},
    progressList: [],
    svgProgressBlockWise:[],
    partList: [],
    trackerList: [],
    currentCount: {},
    svgMap: '',
    bomList: [],
    counts: {},
    blocks: [],
    overAllSVG: [],
    list: {},
    bulkAllData: {},
    pierlegends: {},
    typeData: {},
    mapSize: [],
    partTrackerTypes: {},
    bomTrackerTypes: {},
    projectBom: {},
});


export const getProject = atom(null, async (_, set, args) => {
    if (args) {
        set(dashboardAtoms, (prev) => ({ ...prev, projectList: args }));
    }
});

export const getActivity = atom(null, async (_, set, _args) => {
    const res = await getActivities()
    if (res) {
        set(dashboardAtoms, (prev) => ({ ...prev, constructionList: res.data }));
    }
});


export const getConstructionProgressList = atom(null, async (_, set, args) => {
    const res = await getConstructionProgress(args);
    if (res) {
        set(dashboardAtoms, (prev) => ({ ...prev, progressList: res.data }));
    }
});
export const getConstructionProgressListBlockWise = atom(null, async (_, set, args) => {
    const res = await getSVGConstructionProgressBlockWise(args);
    if (res) {
        set(dashboardAtoms, (prev) => ({ ...prev, svgProgressBlockWise: res.data }));
    }
});


export const fetchPartsAtom = atom(
    null,
    async (get, set, args) => {
        let res = await getPartList()
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, partList: res.data }));
        }
    }
)

export const fetchTrackers = atom(
    null,
    async (get, set, args) => {
        const res = await getTrackers(args)
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, trackerList: res.data }));
        }
    }
)

export const fetchCount = atom(
    null,
    async (get, set, args) => {
        let res = await getCount(args);
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, currentCount: res.data }));
        }
    }
)

export const fetchMapRender = atom(
    null,
    async (get, set, args) => {
        let res = await axiosInstance.get(`/projects/svg_details`)
        let tempRes = await axiosInstance.get(`/file_upload/download?id=${res.data?.upload_id}`)
        let newRes = await fetch(tempRes.data)
        let text = await newRes.text()
        if (text) {
            set(dashboardAtoms, (prev) => ({ ...prev, svgMap: text }));
        }
    }
)

export const fetchbomdetails = atom(
    null,
    async (get, set, args1, args2) => {
        if (args1 && args2) {
            const res = await getsvgbomlistS(args1)
            if (res) {
                set(dashboardAtoms, (prev) => ({ ...prev, bomList: res?.data }));
            }
        } else {
            const res = await getbomlist(args1)
            if (res) {
                set(dashboardAtoms, (prev) => ({ ...prev, bomList: res?.data }));
            }
        }
    }
)

export const fetchBlocks = atom(
    null,
    async (get, set, args) => {
        const res = await getBlockData()
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, blocks: res?.data }));
        }
    }
)

export const fetchOverallCpSVG = atom(
    null,
    async (get, set, args) => {
        const res = await getOverAllSvg()
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, overAllSVG: res?.data }));
        }
    }
)

export const fetchActivitiesAtom = atom(
    null,
    async (get, set, args) => {
        const res = await get_all_activities()
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, list: res?.data }));
        }
    }
)

export const fetchBulkData = atom(
    null,
    async (get, set, args) => {
        const res = await getBulkBlock(args)
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, bulkAllData: res?.data }));
        }
    }
)


export const fetchpierlegends = atom(
    null,
    async (get, set, _args) => {
        let res = await getPierLegends();
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, pierlegends: res.data }));
        }
    }
)


export const fetchTypeData = atom(
    null,
    async (get, set, args1,args2) => {
        const res = await getTypeData(args1,args2)
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, typeData: res?.data }));
        }
    }
)


export const fetchMapSize = atom(
    null,
    async (get, set, args) => {
        let res = await getMapSize(args)

        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, mapSize: res?.data }));
        }
    }
)


export const fetchPartTrackerTypes = atom(
    null,
    async (get, set, args) => {
        let res = await axiosInstance.get(`/tracker/part_per_tracker_type`)
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, partTrackerTypes: res.data }));
        }
    }
)


export const fetchProjectBom = atom(
    null,
    async (get, set, args) => {
        let res = await axiosInstance.get(`/projects/activitymilestone/get_distributed_and_installed_bom_for_project`)
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, projectBom: res.data }));
        }
    }
)

export const fetchBomTrackerTypes = atom(
    null,
    async (get, set, args) => {
        let res = await axiosInstance.get(`/bom/get_bom_per_tracker_type_v2`)
        if (res) {
            set(dashboardAtoms, (prev) => ({ ...prev, bomTrackerTypes: res.data }));
        }
    }
)

export default dashboardAtoms;